import { type OptimizelyDecision } from '@optimizely/react-sdk';
import { type PerksList } from '@fff-web/fff-ui-shared/Plans';
import { type HeroBannerProps } from '@fff-web/fff-ui-shared/HeroBanner';

export type IProductsList = Array<{
  imagePublicId: string;
  title: string;
  caption: string;
}>;

type HeroBannerOptimizely = HeroBannerProps & {
  imageDesktop: string;
  imageMobile: string;
};

export interface IReactivateMembershipContext extends OptimizelyDecision {
  variables: {
    planSectionSubtitle: string;
    planSectionTitle: string;
    seasonalPerks: {
      list: PerksList;
    };
    annualPerks: {
      list: PerksList;
    };
    heroBanner: HeroBannerOptimizely;
    howItWorks: {
      headline: string;
      productsList: IProductsList;
    };
    seasonMembershipName: string;
    increasedPrice: number;
    annualCardSubtitle: string;
  };
}

export type MyMembershipContextType = {
  growthMyMembership: OptimizelyDecision;
  myAccountPath?: string;
  showReactivationContent: boolean;
};

export const initialStateDecision: OptimizelyDecision = {
  variationKey: null,
  userContext: {
    id: null,
    attributes: undefined,
  },
  enabled: false,
  variables: {},
  ruleKey: null,
  flagKey: '',
  reasons: [],
};

const defaultReactivateMyMembershipContext: MyMembershipContextType = {
  growthMyMembership: initialStateDecision,
  showReactivationContent: false,
};

export default defaultReactivateMyMembershipContext;
